// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable guard-for-in */
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';

const SELECTOR_WRAPPER = '.p-competition-eligibility-details-form';
const SELECTOR_FORM_WRAPPER = '.p-competition-eligibility-details-form__container';
const SELECTOR_FORM = '.p-competition-eligibility-details-form__form';
const SELECTOR_FORM_BUTTON = '.p-competition-eligibility-details-form__button';

const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class CompetitionElegibilityDetails {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.formWrapper = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.form = SelectorEngine.findOne(SELECTOR_FORM, this.formWrapper);
		this.stepsApi = Manipulator.getDataAttribute(this.form, 'steps-api');
		this.submitApi = Manipulator.getDataAttribute(this.form, 'submit-api');
		this.householdId = Manipulator.getDataAttribute(this.form, 'household-id');
		this.formButton = SelectorEngine.findOne(SELECTOR_FORM_BUTTON, this._wrapper);
		this._errorContainer = SelectorEngine.findOne('.p-competition-eligibility-details-form__error-container', this.formWrapper);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);
		this._successContainer = SelectorEngine.findOne('.p-competition-eligibility-details-form__success', this._wrapper);
		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});
		this.getFormDetails();
	}

	async getFormDetails() {
		try {
			const url = this.stepsApi;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		// Inject householdId to email question to be used in duplicate email check api call.
		const updatedStepsData = stepsData.map((question) => {
			if (question.fieldName === 'email') {
				return {
					...question,
					householdId: this.householdId
				};
			}
			return question;
		});

		this.formGenerator = new FormGenerator(this.form, {
			questions: updatedStepsData,
			totalSteps: 2,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			isBackButtonEnabled: true,
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			},
			saveAddress: false
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});

		this.formGenerator.onSubmit( async () => {
			const isFormValid = await this.formGenerator.formValidation();
			if (isFormValid) {
				this.submitSupportForm(this.answerList);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	async submitSupportForm(answers) {
		startLoadingAnimation(true);
		const payload = {	
			address: answers?.address,
			contactNumber: answers?.contactNumber,
			email: answers?.email,
			playCountyDetails: answers?.playCountyDetails,
			playCounty: answers?.playCounty,
			disability: {responseLevel1: answers?.disability, responseLevel2: answers?.disability_type?.map((item) => item.value)},
			ethnicity: { responseLevel1: answers?.ethnicity, responseLevel2: answers?.ethnicity_subgroups},
			sexualOrientation: answers?.sexualOrientation,
			Faith: answers?.Faith

		};
		console.log(payload);
		const url = this.submitApi;
		const responseData = await Request.post(url, payload, {
			local: IS_LOCAL,
			req: {
				apiMode: ApiMode.LtaError
			}
		});

		const { success, response } = responseData;
		if (success) {
			this.formWrapper.classList.add('u-hidden');
			this._successContainer.classList.remove('u-hidden');
			this._successContainer.scrollIntoView();
		} else {
			this.formGenerator.enableSubmitButton();
			this._errorContainer.classList.remove('u-hidden');
			this._errorContainer.scrollIntoView();
		}
		stopLoadingAnimation(true);	
	}
}

const globalCompetitionElegibilityDetails = new CompetitionElegibilityDetails();
export default globalCompetitionElegibilityDetails;
